import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VersionCheckService } from '@shared/services/version-check.service';
import { DomChangeDirective as appDomChange } from './shared/directives/dom-change/dom-change.directive';

registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-root',
  templateUrl: `./app.component.html`,
  standalone: true,
  imports: [RouterModule],
  hostDirectives: [appDomChange],
})
export class AppComponent implements OnInit {
  constructor(private versionCheckService: VersionCheckService) {}

  ngOnInit(): void {
    this.versionCheckService.initVersionCheck();
  }
}
